// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"featured-blog-items-component_uk-open__DOwUa","grecaptcha-badge":"featured-blog-items-component_grecaptcha-badge__TrxT0","featured-blog-items__card":"featured-blog-items-component_featured-blog-items__card__HCTvF","featured-blog-items__card-image":"featured-blog-items-component_featured-blog-items__card-image__bDQ12","featured-blog-items__card-title":"featured-blog-items-component_featured-blog-items__card-title__YVggZ"};
    if(module.hot) {
      // 1750775030710
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  